var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.activity
    ? _c(
        "a",
        {
          staticClass: "activity-card",
          attrs: {
            href: _vm.route(
              "nl.activity",
              _vm.activity.slug != null
                ? { slug: _vm.activity.slug }
                : { slug: _vm.activity.post_name }
            )
          }
        },
        [
          _c("div", { ref: "card", staticClass: "media-container mb-12" }, [
            _c(
              "div",
              {
                staticClass: "ar",
                style: {
                  "padding-top": (_vm.arHeight / _vm.arWidth) * 100 + "%"
                }
              },
              [
                _vm.activity.acf &&
                _vm.activity.acf.content &&
                _vm.activity.acf.content.images
                  ? _c(
                      "div",
                      {
                        ref: "images",
                        staticClass: "images",
                        class: {
                          "opacity-hover":
                            _vm.activity.acf.content.video_id != null &&
                            _vm.activity.acf.content.video_id != ""
                        },
                        on: {
                          mouseenter: function($event) {
                            return _vm.cardHover()
                          },
                          mouseleave: function($event) {
                            return _vm.cardLeave()
                          }
                        }
                      },
                      [
                        _vm.activity.acf.content.video_id != null &&
                        _vm.activity.acf.content.video_id != ""
                          ? [
                              _c("img", {
                                ref: "primary",
                                staticClass: "primary-image transition-opacity",
                                attrs: {
                                  src:
                                    _vm.activity.acf.content.images[0].sizes
                                      .medium_large,
                                  alt: _vm.activity.post_name
                                }
                              }),
                              _vm._v(" "),
                              _vm.cardLoaded
                                ? _c(
                                    "div",
                                    { staticClass: "video-wrapper" },
                                    [
                                      _c("vimeo-player", {
                                        ref: "videoplayer",
                                        attrs: {
                                          "video-id":
                                            _vm.activity.acf.content.video_id,
                                          "player-width": _vm.videoClientWidth,
                                          "player-height":
                                            _vm.videoClientHeight,
                                          autoplay: false,
                                          loop: true,
                                          options: _vm.vimeoOptions
                                        },
                                        on: { ready: _vm.videoPlayerReady }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          : [
                              _c("img", {
                                ref: "primary",
                                staticClass: "primary-image",
                                attrs: {
                                  src:
                                    _vm.activity.acf.content.images[0].sizes
                                      .medium_large,
                                  alt: _vm.activity.post_name
                                }
                              }),
                              _vm._v(" "),
                              _vm.fade_from_image
                                ? _c("img", {
                                    ref: "fade_from",
                                    staticClass: "crossfade-from-images",
                                    attrs: {
                                      src: _vm.fade_from_image,
                                      alt: _vm.activity.post_name
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.fade_to_image
                                ? _c("img", {
                                    ref: "fade_to",
                                    staticClass: "crossfade-to-images",
                                    attrs: {
                                      src: _vm.fade_to_image,
                                      alt: _vm.activity.post_name
                                    }
                                  })
                                : _vm._e()
                            ]
                      ],
                      2
                    )
                  : _vm._e()
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", {
            staticClass: "title small",
            domProps: {
              innerHTML: _vm._s(
                _vm.activity.post_title
                  ? _vm.activity.post_title
                  : _vm.activity.title.rendered
              )
            }
          }),
          _vm._v(" "),
          _vm.activity.acf &&
          _vm.activity.acf.content &&
          _vm.activity.acf.content.highlighted_title &&
          !_vm.$root.isMobile
            ? _c(
                "p",
                {
                  staticClass: "text-dark font-weight-light small mt-4 subtitle"
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.activity.acf.content.highlighted_title) +
                      "\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.categories && _vm.categories.length > 0
            ? _c(
                "div",
                {
                  key: _vm.categories.length,
                  ref: "categories",
                  staticClass: "tag-row mt-12"
                },
                _vm._l(_vm.categories, function(category, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      ref: "tags",
                      refInFor: true,
                      staticClass: "tag-col"
                    },
                    [
                      _c("div", {
                        staticClass: "tag tag-accent-light tag-xs",
                        domProps: { innerHTML: _vm._s(category.name) }
                      })
                    ]
                  )
                }),
                0
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }